import React, { useCallback, useState } from "react";
import { Button, Modal } from "antd";
import { ButtonHTMLType, ButtonType } from "antd/lib/button/button";
import { SizeType } from "antd/lib/config-provider/SizeContext";

interface Props {
  buttonCaption: string;
  buttonType?: ButtonType;
  buttonHtmlType?: ButtonHTMLType;
  buttonSize?: SizeType;
  modalTitle?: string;
  children?: React.ReactNode;
  modalFooter?: React.ReactNode;
  cancel?: boolean;
}

const ModalWrapper: React.FC<Props> = ({
  buttonCaption,
  buttonType = "primary",
  buttonHtmlType,
  buttonSize = "small",
  modalTitle,
  children,
  modalFooter = null,
  cancel = false,
}) => {
  const [modalVisibility, setModalVisibility] = useState<boolean>(false);

  const showModal = useCallback(() => {
    setModalVisibility(true);
  }, []);

  const hideModal = useCallback(() => {
    setModalVisibility(false);
  }, []);

  return (
    <>
      <Button
        type={buttonType}
        htmlType={buttonHtmlType}
        onClick={showModal}
        size={buttonSize}
      >
        {buttonCaption}
      </Button>

      <Modal
        visible={modalVisibility}
        footer={modalFooter}
        onCancel={hideModal}
        title={modalTitle}
        cancelButtonProps={{
          onClick: hideModal,
        }}
      >
        {children}
      </Modal>
    </>
  );
};

export default ModalWrapper;
